import React from "react";
import {Col, Container, Row} from "reactstrap";
import Intro from "../containers/Intro";
import "../css/appSkeleton.scss";
import Header from "./Header";
import TestView from "../containers/TestView";
import ResultsView from "../containers/ResultsView";
import ThankYou from "./ThankYou";
import Loading from "../containers/Loading";
import Footer from "./Footer";

const AppSkeleton = ({showTest = false, showResults = false, requireContact = false}) => (
    <Container fluid className={"test-bg"}>
        <Header/>
        <Loading/>
        <Row>
            <Col md={{size: 12, offset: 0}} lg={{size: 8, offset: 2}}>
                <Container className={"test-body"}>
                    {requireContact ? <ThankYou/> : showResults ? <ResultsView/> : showTest ? <TestView/> : <Intro/>}
                </Container>
            </Col>
        </Row>
        <Footer/>
    </Container>
);

export default AppSkeleton